import * as d3 from 'd3-color';
import { LOOP_COLOR_LIST } from '@shared/constants/theme.constant';
import { get as lodashGet } from 'lodash';

export const createDownloadFile = (data: any, filename: any) => {
  const blob = new Blob([data], { type: data.type });
  const objectUrl: string = URL.createObjectURL(blob);
  const a: HTMLAnchorElement = document.createElement(
    'a',
  ) as HTMLAnchorElement;

  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();

  document.body.removeChild(a);
  URL.revokeObjectURL(objectUrl);
};

export const getColorsMap = (index: number, light = 0.26): string => {
  const color = LOOP_COLOR_LIST[index % LOOP_COLOR_LIST.length];
  const hsl = d3.hsl(color);
  hsl.l += light;
  return hsl.toString();
};

export type Lang = 'th' | 'en';

export function hasNullOrUndefinedValue(
  obj: Record<string, any>,
): boolean {
  return Object.values(obj).some(
    (value) => value === null || value === undefined,
  );
}

/**
 * Build custom search function for NgSelect.searchFn
 */
export function buildSearchByKeysFunc(
  keys: string[],
): (term: string, item: any) => boolean {
  return (term, item) => {
    term = term.toLowerCase();
    for (const key of keys) {
      const val = lodashGet(item, key, '');
      if (val.toLowerCase().indexOf(term) > -1) {
        return true;
      }
    }
    return false;
  };
}
